import type { MusicService } from '../types';
import { ImporterID, MusicAPIIntegrationID } from '../ids';
import { musicServiceMessages } from '../messages';

export const soundcloud: MusicService = {
  id: 'soundcloud',
  appId: 'sound-cloud',
  name: 'SoundCloud',
  shortName: 'SoundCloud',
  isSupported: true,
  isComingSoon: false,
  areStatsSupported: false,
  areStatsComingSoon: false,
  isAlbumTransferSupported: true,
  color: {
    primary: '#ff5500',
    label: '#FF5500',
    background: '#8b7366',
  },
  importerID: ImporterID.SoundCloud,
  musicAPIID: MusicAPIIntegrationID.SoundCloud,
  linkType: 'soundcloud',
  limits: {
    tracksPerPlaylist: 500,
  },
  assets: {
    logo: { light: 'soundcloud-light.svg', dark: 'soundcloud-dark.svg' },
    logoPadding: { light: 'soundcloud-light-padding.svg', dark: 'soundcloud-dark-padding.svg' },
    logoColor: { light: 'soundcloud-color-light.svg', dark: 'soundcloud-color-dark.svg' },
    logoColorPadding: {
      light: 'soundcloud-color-light-padding.svg',
      dark: 'soundcloud-color-dark-padding.svg',
    },
    logoOnBackground: 'soundcloud-dark.svg',
  },
  whatIsDescription: musicServiceMessages.soundcloudWhatIs,
  authenticatedApiCapabilities: {
    doesSupportUpdatingPlaylists: true,
    doesSupportRemovingPlaylists: true,
    doesSupportRemovingTracks: true,
    doesSupportMovingTracks: true,
    doesSupportAddingTracksToLibrary: true,
    doesSupportRemovingTracksFromLibrary: true,
    doesSupportFetchingLibraryAlbums: false,
    doesSupportFetchingAlbums: false,
    doesSupportFetchingAlbumTracks: false,
    doesSupportAddingAlbums: false,
    doesSupportRemovingAlbums: false,
    doesSupportFetchingLibraryArtists: true,
    doesSupportFetchingArtists: true,
    doesSupportAddingArtistsToLibrary: true,
    doesSupportRemovingArtistsFromLibrary: true,
    doesSupportSearchByISRC: false,
    doesReturnISRC: true,
    doesReturnPreviewURL: false,
    doesReturnUserEmail: false,
    doesReturnUserCountry: true,
    maxLimit: 50,
  },
};
